import { init, addMessages, register } from 'svelte-i18n';
import { browser } from '$app/environment';
import koMessages from './messages/ko';

export let defaultLocale = 'ko';
export const availableLocales = ['ko', 'en', 'ja'];

if (browser) {
    const browserLocale = navigator.language.split('-')[0];
    if (availableLocales.includes(browserLocale)) {
        defaultLocale = browserLocale;
    }
}

type Messages = {
    [key: string]: any;
};
export type KeyType = 'origin' | 'fullkey' | 'lastkey';

// 키 표시(DevHelpWidget)에서 원문으로 되돌릴 때 다시 넣을 원본 사전
const loadedMessages: Record<string, Messages> = { ko: koMessages };
// Dev Tools 언어 전환은 새로고침 없이 일어나므로, 나중에 불러온 언어에도 현재 키 표시를 적용한다
let showKey: KeyType = 'origin';

function transformMessagesToKeys(messages: Messages): Messages {
    function transform(obj: Messages, prefix = ''): Messages {
        const result: Messages = {};
        for (const key in obj) {
            const fullKey = prefix ? `${prefix}.${key}` : key;
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                result[key] = transform(obj[key], fullKey);
            } else {
                result[key] = fullKey;
            }
        }
        return result;
    }

    return transform(messages);
}
function transformMessagesToLastKeys(messages: Messages): Messages {
    function transform(obj: Messages): Messages {
        const result: Messages = {};
        for (const key in obj) {
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                result[key] = transform(obj[key]);
            } else {
                result[key] = key;
            }
        }
        return result;
    }

    return transform(messages);
}

function messagesForKeyType(messages: Messages, keyType: KeyType): Messages {
    if (keyType === 'fullkey') return transformMessagesToKeys(messages);
    if (keyType === 'lastkey') return transformMessagesToLastKeys(messages);
    return messages;
}

export function setShowI18nKey(value: KeyType) {
    showKey = value;
    for (const [lang, messages] of Object.entries(loadedMessages)) {
        addMessages(lang, messagesForKeyType(messages, value));
    }
}

addMessages('ko', koMessages); // 디폴트 언어셋은 sync로 불러오지 않으면 간헐적으로 로딩이 늦어서 랜더링중에 에러가 발생
register('en', async () => {
    const enMessages = (await import('./messages/en')).default;
    loadedMessages.en = enMessages;
    return messagesForKeyType(enMessages, showKey);
});

register('ja', async () => {
    const jaMessages = (await import('./messages/ja')).default;
    loadedMessages.ja = jaMessages;
    return messagesForKeyType(jaMessages, showKey);
});

init({
    fallbackLocale: defaultLocale,
    initialLocale: defaultLocale,
});
